export const buildAvailabilityChartData = (availabilityPoints, durationSeries, label) => {
  if (!availabilityPoints?.length) return null
  const durByTs = new Map(
    (durationSeries || []).map(([ts, val]) => [Number(ts), parseFloat(val)])
  )
  return {
    labels: availabilityPoints.map((point) => point.t / 1000),
    datasets: [
      {
        label,
        data: availabilityPoints.map((point) => {
          if (point.v !== 1) return null
          const n = durByTs.get(point.t / 1000)
          return Number.isFinite(n) ? n : null
        }),
        borderColor: '#9385ff',
        backgroundColor: 'rgba(147,133,255,0.12)',
        fill: 'origin',
        tension: 0.2,
        spanGaps: false,
        pointRadius: 0,
        borderWidth: 1.5,
      },
    ],
  }
}

export const buildChannelsChartData = (series) => {
  const online = series?.channels_online
  const recording = series?.channels_recording
  if (!online?.length && !recording?.length) return null
  const base = online?.length ? online : recording
  return {
    labels: base.map((point) => Number(point[0])),
    datasets: [
      {
        label: 'На связи',
        data: (online || []).map((point) => parseFloat(point[1])),
        borderColor: 'rgba(66, 211, 146, 1)',
        backgroundColor: 'rgba(66, 211, 146, 0.12)',
        fill: true,
        tension: 0.3,
        pointRadius: 0,
        borderWidth: 2,
      },
      {
        label: 'Под записью',
        data: (recording || []).map((point) => parseFloat(point[1])),
        borderColor: 'rgba(110, 88, 255, 1)',
        backgroundColor: 'rgba(110, 88, 255, 0.12)',
        fill: true,
        tension: 0.3,
        pointRadius: 0,
        borderWidth: 2,
      },
    ],
  }
}

const EVENT_COLORS = {
  card_success: 'rgba(66, 211, 146, 0.9)',
  card_failure: 'rgba(255, 89, 119, 0.9)',
  face_success: 'rgba(64, 230, 255, 0.9)',
  face_failure: 'rgba(246, 201, 76, 0.9)',
  fingerprint_success: 'rgba(110, 88, 255, 0.9)',
  fingerprint_failure: 'rgba(255, 114, 210, 0.9)',
  password_success: 'rgba(180, 244, 97, 0.9)',
  password_failure: 'rgba(255, 179, 71, 0.9)',
  other_success: 'rgba(148, 163, 184, 0.9)',
  other_failure: 'rgba(100, 116, 139, 0.9)',
}

const TRIGGER_COLORS = {
  alertstream: 'rgba(239, 68, 68, 0.9)',
  zonepoll: 'rgba(246, 201, 76, 0.9)',
  simulated: 'rgba(110, 88, 255, 0.9)',
  unknown: 'rgba(148, 163, 184, 0.9)',
}

export const buildTriggersChartData = (series) => {
  const triggerSeries = series?.triggers
  if (!triggerSeries?.length) return null

  const firstSeries = triggerSeries[0]?.values || []
  if (!firstSeries.length) return null

  return {
    labels: firstSeries.map((point) => Number(point[0])),
    datasets: triggerSeries.map((entry) => ({
      label: entry.source || 'unknown',
      data: (entry.values || []).map((point) => {
        const n = parseFloat(point[1])
        return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0
      }),
      backgroundColor: TRIGGER_COLORS[entry.source] || TRIGGER_COLORS.unknown,
      borderRadius: 6,
    })),
  }
}

export const buildEventsChartData = (series, overviewDoorId = '1') => {
  const eventSeries = series?.events?.length ? series.events : series?.events_5m
  if (!eventSeries?.length) return null

  const doorEvents = eventSeries.filter((entry) => entry.door_id === overviewDoorId || !entry.door_id)
  if (doorEvents.length === 0) return null

  const firstSeries = doorEvents[0]?.values || []
  if (!firstSeries.length) return null

  const byCategory = {}
  doorEvents.forEach((entry) => {
    const key = `${entry.category}_${entry.result}`
    if (!byCategory[key]) byCategory[key] = { label: `${entry.category} (${entry.result})`, values: [] }
    byCategory[key].values = entry.values
  })

  return {
    labels: firstSeries.map((point) => Number(point[0])),
    datasets: Object.entries(byCategory).map(([key, data]) => ({
      label: data.label,
      data: data.values.map((point) => {
        const n = parseFloat(point[1])
        return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0
      }),
      backgroundColor: EVENT_COLORS[key] || 'rgba(148, 163, 184, 0.9)',
      borderRadius: 6,
    })),
  }
}
